module.exports = __webpack_public_path__ + "media/images/malvinas/Sist_Malvinas_Negativo-ff74aebfd064a2029d68fcefafbcdd30.svg";